<template>
  <div>

    <v-alert
      prominent
      type="warning"
      icon="mdi-map-marker-question-outline"
      v-if="isAdmin"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ $t("forms.info.warningDirectEdit") }}
        </v-col>
        <v-col class="shrink">
          <v-btn
            to="/manage/edit/pressNews"
          >
            <v-icon
              left
              dark
            >
              mdi-arrow-right-circle
            </v-icon>
            {{ $t("forms.info.gotoDirectEdit") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <PendingUserForms
      v-if="pendingForms.length"
      :title="$t('table.pressNews.pendingForms')"
      :items="pendingForms"
    />

    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
                class="text-left"
              >
                <v-list-item :to="form.path">
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="pressNews"
      :search="search"
      class="elevation-1 table-cursor-hand mt-4"
      :items-per-page="15"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      sort-by="date"
      sort-desc
      @click:row="clickRow"
      :loading="loading"
      :loading-text="$t('table.loading')"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.media_type="{ item }">
        {{ $t("pressNew.media_types." + item.media_type) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "../forms/PendingUserForms";
export default {
  components: { PendingUserForms },
  data: () => ({
    pendingForms: [{}],
    loading: true,
    search: "",
    pressNews: [],
    forms: [
      {
        icon: "mdi-plus",
        title: "pressNew.forms.newPressNew",
        path: "/my-forms/pressNew/newPressNew"
      }
    ]
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.title"),
          value: "title"
        },
        {
          text: this.$t("table.media_type"),
          value: "media_type"
        },
        {
          text: this.$t("table.media"),
          value: "media"
        },
        {
          text: this.$t("table.date"),
          value: "date"
        }
      ];
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/user/news";
      axios
        .get(path)
        .then(response => {
          this.pressNews = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });

      path =
        this.$store.state.endpoint + "/user/moderatedOperations/pending/news";
      axios
        .get(path)
        .then(response => {
          this.pendingForms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    clickRow(item) {
      this.$router.push({ path: `/pressNews/${item.id}` });
    }
  }
};
</script>
